import { Box, Flex, HStack, Input, Radio, RadioGroup, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { normalizeFeeType } from './calc/xirrFee';

export const FEE_TYPE_ANNUAL_XIRR = 'Annual XIRR';
export const FEE_TYPE_MONTHLY_XIRR = 'Monthly XIRR';

function FacilityFeeTypeRow({
  feeType,
  feePct,
  onChangeFeeType,
  onChangeFeePct,
  compact = false,
}) {
  return (
    <Box>
      <Text fontSize={compact ? 'xs' : 'sm'} color={compact ? 'gray.600' : undefined} mb={compact ? 0.5 : 1}>
        Fee / XIRR %
      </Text>
      <Flex align="center" gap={compact ? 2 : 4} flexWrap="wrap">
        <RadioGroup
          value={normalizeFeeType(feeType)}
          onChange={onChangeFeeType}
          colorScheme="purple"
        >
          <HStack spacing={compact ? 2 : 4}>
            <Radio size={compact ? 'sm' : 'md'} value={FEE_TYPE_ANNUAL_XIRR}>
              Annual
            </Radio>
            <Radio size={compact ? 'sm' : 'md'} value={FEE_TYPE_MONTHLY_XIRR}>
              Monthly
            </Radio>
          </HStack>
        </RadioGroup>
        <Input
          aria-label="Fee / XIRR %"
          type="number"
          size={compact ? 'sm' : 'md'}
          w={compact ? '72px' : '120px'}
          value={feePct}
          onChange={(e) => onChangeFeePct(Number(e.target.value) || 0)}
        />
      </Flex>
    </Box>
  );
}

FacilityFeeTypeRow.propTypes = {
  feeType: PropTypes.string,
  feePct: PropTypes.number,
  onChangeFeeType: PropTypes.func.isRequired,
  onChangeFeePct: PropTypes.func.isRequired,
  compact: PropTypes.bool,
};

export default FacilityFeeTypeRow;
